import {
  packingTemplateIdFormat,
  productIdFormat,
  transferOrderIdFormat,
  transferOrderProductIdFormat,
} from "@redotech/redo-ids/ids";
import {
  PackingMode,
  PackingModeSchema,
} from "@redotech/redo-model/inventory/packing-mode";
import * as z from "zod";
import { TransferOrderKind } from "./transfer-types";

export const updateTransfer = {
  name: "updateTransfer" as const,
  input: z.object({
    transferId: transferOrderIdFormat.schema,
    kind: TransferOrderKind.optional(),
    notes: z.string().nullish().optional(),
    tags: z.array(z.string()).optional(),
    productsToAdd: z
      .array(
        z.object({
          productId: productIdFormat.schema,
          expectedQuantity: z.number().int().min(1),
          packingMode: PackingModeSchema.default(PackingMode.INDIVIDUAL),
          packingTemplateId: packingTemplateIdFormat.schema
            .nullable()
            .optional(),
          enteredQuantity: z.number().int().default(0),
        }),
      )
      .optional(),
    productsToRemove: z.array(transferOrderProductIdFormat.schema).optional(),
    productsToUpdate: z
      .array(
        z.object({
          id: transferOrderProductIdFormat.schema,
          expectedQuantity: z.number().int().min(1),
          packingMode: PackingModeSchema.optional(),
          packingTemplateId: packingTemplateIdFormat.schema
            .nullable()
            .optional(),
          enteredQuantity: z.number().int().optional(),
        }),
      )
      .optional(),
  }),
  output: z.object({ success: z.literal(true) }),
};
